import * as api from "../api/index";

export const UserService = {
  createAdminUser,
  updateAdminUser,
  changeAdminPassword,
  getAllAdminUserList,
  createOwnerUser,
  approveOrRejectOwner,
  getAllOwnerList,
  getAllOwnerListWithoutPagination,
  getAllOwnerCompanyListWithoutPagination,
  createChildUser,
  getAllChildUserList,
  updateChildUser,
  changeChildPassword,
  getOwnerDetailsById,
  changeOwnerPassword,
  getApprovePendingOwnerList,
  updateOwnerUser,
  updateOwnerSystemConfig,
  updateOwnerSystemConfigPassword,
  createReportUser,
  updateReportUserDetails,
  updateReportUserPassword,
  getAllReportUser,
  getApprovePendingChildUserList,
  approveOrRejectChildUser,
  getOwnerProfileDetails,
  getOwnerRatecardDetails,
  searchOwnerByCompanyName,
  getChildListByMaskId,
  getAllApprovePendingChildList,
  updateUserSmsConfigurations,
  updateUserDataConfigurations
};

async function updateUserDataConfigurations(formData) {
  try {
    const { data } = await api.updateUserDataConfigurations(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateUserSmsConfigurations(formData) {
  try {
    const { data } = await api.updateUserSmsConfigurations(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
async function createAdminUser(formData) {
  try {
    const { data } = await api.createAdminUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateAdminUser(formData) {
  try {
    const { data } = await api.updateAdminUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeAdminPassword(formData) {
  try {
    const { data } = await api.changeAdminPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllAdminUserList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllAdminUserList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createOwnerUser(formData) {
  try {
    const { data } = await api.createOwnerUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function approveOrRejectOwner(formData) {
  try {
    const { data } = await api.approveOrRejectOwner(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getApprovePendingOwnerList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getApprovePendingOwnerList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllOwnerList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllOwnerList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllOwnerListWithoutPagination() {
  try {
    const { data } = await api.getAllOwnerListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeOwnerPassword(formData) {
  try {
    const { data } = await api.changeOwnerPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateOwnerSystemConfig(formData) {
  try {
    const { data } = await api.updateOwnerSystemConfig(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateOwnerSystemConfigPassword(formData) {
  try {
    const { data } = await api.updateOwnerSystemConfigPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateOwnerUser(formData) {
  try {
    const { data } = await api.updateOwnerUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getOwnerDetailsById(formData) {
  try {
    const { data } = await api.getOwnerDetailsById(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllOwnerCompanyListWithoutPagination() {
  try {
    const { data } = await api.getAllOwnerCompanyListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createChildUser(formData) {
  try {
    const { data } = await api.createChildUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllChildUserList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllChildUserList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateChildUser(formData) {
  try {
    const { data } = await api.updateChildUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeChildPassword(formData) {
  try {
    const { data } = await api.changeChildPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createReportUser(formData) {
  try {
    const { data } = await api.createReportUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateReportUserDetails(formData) {
  try {
    const { data } = await api.updateReportUserDetails(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateReportUserPassword(formData) {
  try {
    const { data } = await api.updateReportUserPassword(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllReportUser(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllReportUser(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getApprovePendingChildUserList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getApprovePendingChildUserList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function approveOrRejectChildUser(formData) {
  try {
    const { data } = await api.approveOrRejectChildUser(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getOwnerProfileDetails() {
  try {
    const { data } = await api.getOwnerProfileDetails();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getOwnerRatecardDetails() {
  try {
    const { data } = await api.getOwnerRatecardDetails();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function searchOwnerByCompanyName(formData) {
  try {
    const { data } = await api.searchOwnerByCompanyName(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChildListByMaskId(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getChildListByMaskId(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getAllApprovePendingChildList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getAllApprovePendingChildList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}